/* JRepairs — theme.js (no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const JR = window.JR || { routes: {}, leadTime: { min: 7, max: 14 } };

  /* ---------- Header: sticky, hides on scroll down, reveals on scroll up ----------
     No height change on scroll (that shifted the page and caused jitter). Hysteresis on both states. */
  const header = $('[data-header]');
  const bar = header && header.closest('.section-header');
  if (header && bar) {
    let lastY = window.scrollY, barH = bar.offsetHeight, travel = 0;
    const measure = () => { barH = bar.offsetHeight; bar.style.setProperty('--bar-h', `${barH}px`); };
    const locked = () => document.documentElement.style.overflow === 'hidden' || header.contains(document.activeElement);
    const update = () => {
      const y = Math.max(0, window.scrollY);
      const dy = y - lastY;
      // solid background: on after 24px, off below 4px
      if (y > 24) header.classList.add('is-scrolled'); else if (y < 4) header.classList.remove('is-scrolled');
      // accumulate travel in one direction before toggling (ignores tiny bounces / momentum jitter)
      travel = (Math.sign(dy) === Math.sign(travel)) ? travel + dy : dy;
      if (y <= barH + 60 || locked()) bar.classList.remove('is-hidden');
      else if (travel > 24) bar.classList.add('is-hidden');
      else if (travel < -12) bar.classList.remove('is-hidden');
      lastY = y;
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => { measure(); update(); });
    document.addEventListener('jr:show-header', () => bar.classList.remove('is-hidden'));
    measure(); update();
  }

  /* ---------- Overlays (menu, cart, search) ---------- */
  let lastFocus = null;
  function openLayer(el, focusSel) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = focusSel ? $(focusSel, el) : $('button, a, input', el);
    setTimeout(() => f && f.focus(), 60);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  const menu = $('[data-mobile-menu]');
  const drawer = () => $('[data-cart-drawer]');
  const search = $('[data-search-overlay]');

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-menu-open]')) { openLayer(menu); $('[data-menu-open]').setAttribute('aria-expanded', 'true'); }
    if (t.closest('[data-menu-close]')) { closeLayer(menu); $('[data-menu-open]')?.setAttribute('aria-expanded', 'false'); }
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openLayer(drawer()); }
    if (t.closest('[data-cart-close]')) closeLayer(drawer());
    if (t.closest('[data-search-open]')) { search.style.display = ''; openLayer(search, 'input[type=search]'); }
    if (t.closest('[data-search-close]') || t === search) closeLayer(search);
    if (t.closest('[data-filter-open]')) $('[data-filters]')?.classList.add('is-open');
    if (t.closest('[data-filter-close]')) $('[data-filters]')?.classList.remove('is-open');
    const a = t.closest('.mobile-menu nav a');
    if (a) closeLayer(menu);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    [menu, drawer(), search].forEach((el) => el && el.classList.contains('is-open') && closeLayer(el));
  });

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Tabs (symptom finder + contact) ---------- */
  function wireTabs(root, tabSel, getPanel) {
    const tabs = $$(tabSel, root);
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const p = getPanel(t);
        if (p) {
          p.hidden = !on;
          if (on) { p.classList.remove('is-entering'); void p.offsetWidth; p.classList.add('is-entering'); }
        }
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        const dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!dir) return;
        e.preventDefault();
        select(tabs[(i + dir + tabs.length) % tabs.length], true);
      });
    });
    return select;
  }
  $$('[data-finder]').forEach((root) => wireTabs(root, '.finder__tab', (t) => document.getElementById(t.getAttribute('aria-controls'))));
  $$('[data-contact-tabs]').forEach((root) => {
    const select = wireTabs(root, '[data-tab]', (t) => $(`[data-panel="${t.dataset.tab}"]`, root));
    if (location.hash === '#general') select($('[data-tab="general"]', root));
  });

  /* ---------- Delivery estimate (business days) ---------- */
  function addBusinessDays(date, n) {
    const d = new Date(date);
    let added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); const day = d.getDay(); if (day !== 0 && day !== 6) added++; }
    return d;
  }
  const fmt = new Intl.DateTimeFormat('en-CA', { month: 'short', day: 'numeric' });
  $$('[data-eta]').forEach((el) => {
    const min = parseInt(el.dataset.leadMin, 10) || JR.leadTime.min;
    const max = parseInt(el.dataset.leadMax, 10) || JR.leadTime.max;
    const out = $('[data-eta-range]', el);
    if (out) out.textContent = `${fmt.format(addBusinessDays(new Date(), min))} – ${fmt.format(addBusinessDays(new Date(), max))}`;
  });

  /* ---------- Cart (AJAX + Section Rendering) ---------- */
  async function refreshCart(open = true) {
    const res = await fetch(`${JR.routes.root || '/'}?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer]', html);
    const current = drawer();
    if (fresh && current) {
      const wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (open && !wasOpen) openLayer(current);
    }
    const cart = await (await fetch(`${JR.routes.cart}.js`)).json();
    $$('[data-cart-count]').forEach((c) => { c.textContent = cart.item_count; c.dataset.count = cart.item_count; });
    $$('[data-cart-open]').forEach((b) => b.setAttribute('aria-label', `Cart, ${cart.item_count} items`));
    return cart;
  }

  async function addToCart(form, btn) {
    const errBox = $('[data-form-error]', form);
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(`${JR.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
      errBox && (errBox.hidden = true);
      await refreshCart(true);
      document.dispatchEvent(new Event('jr:show-header'));
    } catch (err) {
      if (errBox) { errBox.textContent = err.message; errBox.hidden = false; } else { alert(err.message); }
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('.js-product-form, .js-quick-add')) {
      if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      addToCart(form, e.submitter || $('[type=submit]', form));
    }
  });

  async function changeLine(line, quantity) {
    const scope = drawer();
    scope && scope.classList.add('is-loading');
    await fetch(`${JR.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) }) });
    if ($('[data-cart-page]')) { location.reload(); return; }
    await refreshCart(false);
    drawer() && drawer().classList.remove('is-loading');
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (b) { e.preventDefault(); changeLine(b.dataset.lineQty, b.dataset.qtyValue); }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.dataset.lineInput, i.value);
  });

  /* ---------- Product page ---------- */
  const pSection = $('[data-product-section]');
  if (pSection) {
    const form = $('.js-product-form', pSection);
    const data = JSON.parse($('[data-product-json]', pSection).textContent);
    const idInput = $('[data-variant-id]', pSection);
    const addBtn = $('[data-add-btn]', pSection);
    const addLabel = $('[data-add-label]', pSection);
    const priceEl = $('[data-product-price] .price', pSection);
    const stock = $('[data-stock]', pSection);
    const mainImg = $('.js-gallery-main', pSection);

    const setVariant = () => {
      const chosen = $$('[data-option]:checked', pSection).map((i) => i.value);
      chosen.forEach((v, idx) => { const l = $(`[data-option-label="${idx}"]`, pSection); if (l) l.textContent = v; });
      const v = data.variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to cart' : 'Unavailable';
      stock.textContent = v.available ? 'Available to order' : 'Currently unavailable';
      if (priceEl) priceEl.innerHTML = v.price + (v.compare ? ` <s>${v.compare}</s>` : '');
      const sp = $('[data-sticky-price]'); if (sp) sp.textContent = v.price;
      if (v.image && mainImg) { mainImg.src = v.image; mainImg.removeAttribute('srcset'); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('[data-option]', pSection).forEach((i) => i.addEventListener('change', setVariant));

    $$('[data-qty]', pSection).forEach((b) => b.addEventListener('click', () => {
      const q = $('#Qty', pSection); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.dataset.qty));
    }));

    $$('[data-gallery-thumb]', pSection).forEach((b) => b.addEventListener('click', () => {
      if (mainImg) { mainImg.src = b.dataset.galleryThumb; mainImg.removeAttribute('srcset'); }
      $$('[data-gallery-thumb]', pSection).forEach((x) => x.setAttribute('aria-current', x === b ? 'true' : 'false'));
    }));

    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => addToCart(form, addBtn));
    }
  }

  /* ---------- Product recommendations: always exactly N (Shopify recs first, category fallback tops up) ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    const grid = el.querySelector('[data-rec-grid]');
    const limit = Number(el.dataset.limit) || 4;
    const fallback = Array.from(grid.querySelectorAll('.rec-item'));
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const recs = Array.from(doc.querySelectorAll('[data-rec-grid] .rec-item'));
      if (!recs.length) return; // keep the category fallback
      const seen = new Set();
      const merged = [];
      [...recs, ...fallback].forEach((n) => { const h = n.dataset.handle; if (!seen.has(h) && merged.length < limit) { seen.add(h); merged.push(n); } });
      grid.replaceChildren(...merged.map((n) => document.importNode(n, true)));
    } catch (_) { /* keep fallback */ }
    if (!grid.children.length) el.remove();
  });

  /* ---------- Collection filters: auto-submit ---------- */
  document.addEventListener('change', (e) => {
    const el = e.target.closest('[data-autosubmit]');
    if (!el) return;
    const form = el.form;
    const params = new URLSearchParams(new FormData(form));
    // keep sort + filters together
    $$('[data-filter-form]').forEach((f) => { if (f !== form) new FormData(f).forEach((v, k) => { if (!params.has(k) || k.startsWith('filter')) params.append(k, v); }); });
    const clean = new URLSearchParams();
    params.forEach((v, k) => { if (v !== '' && !clean.getAll(k).includes(v)) clean.append(k, v); });
    location.search = clean.toString();
  });
})();

/* Policy TOC active state */
(() => {
  const links = Array.from(document.querySelectorAll('.policy__toc nav a'));
  if (!links.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === `#${en.target.id}`));
    });
  }, { rootMargin: '-30% 0px -60% 0px' });
  links.forEach((l) => { const t = document.querySelector(l.getAttribute('href')); t && io.observe(t); });
})();

/* ---------- Instant product filter grid [data-pfg] ---------- */
(() => {
  const roots = document.querySelectorAll('[data-pfg]');
  if (!roots.length) return;
  const PAGE = 9;
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  roots.forEach((root) => {
    const grid = root.querySelector('[data-pfg-grid]');
    const items = Array.from(grid.querySelectorAll('.pfg__item'));
    const hide = root.dataset.hide;
    const q = root.querySelector('[data-pfg-q]');
    const clearQ = root.querySelector('[data-pfg-clear-q]');
    const sort = root.querySelector('[data-pfg-sort]');
    const min = root.querySelector('[data-pfg-min]');
    const max = root.querySelector('[data-pfg-max]');
    const side = root.querySelector('[data-pfg-side]');
    const countEl = root.querySelector('[data-pfg-count]');
    const countBtn = root.querySelector('[data-pfg-count-btn]');
    const badge = root.querySelector('[data-pfg-badge]');
    const chips = root.querySelector('[data-pfg-chips]');
    const empty = root.querySelector('[data-pfg-empty]');
    const pager = root.querySelector('[data-pfg-pager]');
    let page = 1;

    // Build facet options from the data on the page
    const facets = {};
    root.querySelectorAll('.pfg__group[data-facet]').forEach((fs) => {
      const key = fs.dataset.facet;
      const values = [...new Set(items.map((i) => i.dataset[key]))].sort((a, b) => a.localeCompare(b));
      if (hide === key || values.length < 2) { fs.hidden = true; facets[key] = { values: [], checked: new Set(), fs }; return; }
      const LIMIT = 7;
      fs.querySelector('[data-pfg-options]').innerHTML = values.map((v, n) => `<label class="pfg__opt${n >= LIMIT ? ' pfg__opt--extra' : ''}"><input type="checkbox" value="${esc(v)}"><span>${esc(v)}</span><em data-c="${esc(v)}">0</em></label>`).join('') +
        (values.length > LIMIT ? `<button type="button" class="pfg__toggle" data-pfg-toggle aria-expanded="false">+ ${values.length - LIMIT} more</button>` : '');
      const tg = fs.querySelector('[data-pfg-toggle]');
      if (tg) tg.addEventListener('click', () => { const open = fs.classList.toggle('is-expanded'); tg.setAttribute('aria-expanded', open); tg.textContent = open ? 'Show less' : `+ ${values.length - LIMIT} more`; });
      facets[key] = { values, checked: new Set(), fs };
    });

    // Restore state from URL
    const params = new URLSearchParams(location.search);
    if (params.get('q')) q.value = params.get('q');
    Object.keys(facets).forEach((k) => (params.get(k) || '').split('|').filter(Boolean).forEach((v) => {
      facets[k].checked.add(v);
      const box = facets[k].fs.querySelector(`input[value="${CSS.escape(v)}"]`); if (box) box.checked = true;
    }));
    if (params.get('sort')) sort.value = params.get('sort');
    if (params.get('min')) min.value = params.get('min');
    if (params.get('max')) max.value = params.get('max');

    const terms = () => q.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const priceOk = (i) => {
      const p = Number(i.dataset.price) / 100;
      return (!min.value || p >= Number(min.value)) && (!max.value || p <= Number(max.value));
    };
    const matches = (i, skip) => {
      const t = terms();
      if (t.length && !t.every((w) => i.dataset.search.includes(w))) return false;
      for (const [k, f] of Object.entries(facets)) if (k !== skip && f.checked.size && !f.checked.has(i.dataset[k])) return false;
      return priceOk(i);
    };

    function render(resetPaging) {
      if (resetPaging) page = 1;
      const visible = items.filter((i) => matches(i));
      // sort
      const s = sort.value;
      const ordered = [...visible].sort((a, b) =>
        s === 'price-asc' ? a.dataset.price - b.dataset.price :
        s === 'price-desc' ? b.dataset.price - a.dataset.price :
        s === 'title-asc' ? a.dataset.title.localeCompare(b.dataset.title) :
        a.dataset.index - b.dataset.index);
      const pages = Math.max(1, Math.ceil(ordered.length / PAGE));
      if (page > pages) page = pages;
      const start = (page - 1) * PAGE;
      items.forEach((i) => { i.hidden = true; });
      ordered.forEach((i, n) => { grid.appendChild(i); i.hidden = n < start || n >= start + PAGE; });
      renderPager(pages, ordered.length, start);
      // facet counts (each facet counts against the other active filters)
      Object.entries(facets).forEach(([k, f]) => f.values.forEach((v) => {
        const c = items.filter((i) => i.dataset[k] === v && matches(i, k)).length;
        const em = f.fs.querySelector(`em[data-c="${CSS.escape(v)}"]`); if (em) em.textContent = c;
        const lab = em && em.closest('.pfg__opt'); if (lab) { lab.classList.toggle('is-zero', c === 0 && !f.checked.has(v)); lab.classList.toggle('is-checked', f.checked.has(v)); }
      }));
      const n = visible.length;
      countEl.textContent = n > PAGE ? `Showing ${Math.min(n, (page - 1) * PAGE + 1)}–${Math.min(n, page * PAGE)} of ${n} parts` : `${n} ${n === 1 ? 'part' : 'parts'}`;
      countBtn.textContent = n;
      empty.hidden = n > 0;
      clearQ.hidden = !q.value;
      // chips + badge
      const active = [];
      if (q.value) active.push({ label: `“${q.value}”`, clear: () => { q.value = ''; } });
      Object.entries(facets).forEach(([k, f]) => f.checked.forEach((v) => active.push({ label: v, clear: () => { f.checked.delete(v); const b = f.fs.querySelector(`input[value="${CSS.escape(v)}"]`); if (b) b.checked = false; } })));
      if (min.value || max.value) active.push({ label: `$${min.value || 0} – ${max.value ? '$' + max.value : 'any'}`, clear: () => { min.value = ''; max.value = ''; } });
      chips.innerHTML = active.map((a, idx) => `<button type="button" class="pfg__chip" data-i="${idx}">${esc(a.label)} ${'×'}</button>`).join('') + (active.length > 1 ? '<button type="button" class="pfg__chip pfg__chip--reset" data-reset>Clear all</button>' : '');
      chips.querySelectorAll('[data-i]').forEach((b) => b.addEventListener('click', () => { active[b.dataset.i].clear(); render(true); }));
      const r = chips.querySelector('[data-reset]'); if (r) r.addEventListener('click', reset);
      const facetCount = Object.values(facets).reduce((s2, f) => s2 + f.checked.size, 0) + (min.value || max.value ? 1 : 0);
      badge.hidden = !facetCount; badge.textContent = facetCount;
      // URL state
      const u = new URL(location.href);
      ['q', 'sort', 'min', 'max', ...Object.keys(facets)].forEach((k) => u.searchParams.delete(k));
      if (q.value) u.searchParams.set('q', q.value);
      if (sort.value !== 'featured') u.searchParams.set('sort', sort.value);
      if (min.value) u.searchParams.set('min', min.value);
      if (max.value) u.searchParams.set('max', max.value);
      Object.entries(facets).forEach(([k, f]) => { if (f.checked.size) u.searchParams.set(k, [...f.checked].join('|')); });
      history.replaceState({}, '', u);
    }
    function renderPager(pages) {
      pager.hidden = pages < 2;
      if (pages < 2) { pager.innerHTML = ''; return; }
      // 1 … 4 5 6 … 12 style window
      const nums = [];
      for (let k = 1; k <= pages; k++) if (k === 1 || k === pages || Math.abs(k - page) <= 1) nums.push(k);
      const parts = []; let prev = 0;
      nums.forEach((k) => { if (k - prev > 1) parts.push('gap'); parts.push(k); prev = k; });
      const arrow = (dir, disabled, label) => `<button type="button" class="pfg__pg pfg__pg--arrow" data-go="${dir}" ${disabled ? 'disabled' : ''} aria-label="${label}"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${dir === 'prev' ? 'm15 6-6 6 6 6' : 'm9 6 6 6-6 6'}"/></svg><span>${dir === 'prev' ? 'Prev' : 'Next'}</span></button>`;
      pager.innerHTML = arrow('prev', page === 1, 'Previous page') +
        parts.map((k) => k === 'gap' ? '<span class="pfg__pg-gap" aria-hidden="true">…</span>' : `<button type="button" class="pfg__pg" data-go="${k}" ${k === page ? 'aria-current="page"' : ''} aria-label="Page ${k}">${k}</button>`).join('') +
        arrow('next', page === pages, 'Next page');
    }
    pager.addEventListener('click', (e) => {
      const b = e.target.closest('[data-go]'); if (!b || b.disabled) return;
      const go = b.dataset.go;
      page = go === 'prev' ? page - 1 : go === 'next' ? page + 1 : Number(go);
      render(false);
      const top = root.getBoundingClientRect().top + window.scrollY - (document.querySelector('[data-header]')?.offsetHeight || 0) - 16;
      if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
    });

    // Sticky sidebar: pins to the top while it fits; if taller than the viewport it pins by its bottom edge,
    // so every filter stays reachable without an inner scrollbar. Stops at the end of the product column.
    const setSticky = () => {
      side.style.top = ''; return; // sidebar is not sticky (client request)
      if (window.innerWidth < 1000) { side.style.top = ''; return; }
      const headerH = (document.querySelector('[data-header]')?.offsetHeight || 0) + 20;
      const room = window.innerHeight - side.offsetHeight - 20;
      side.style.top = `${Math.min(headerH, room)}px`;
    };
    setSticky();
    window.addEventListener('resize', setSticky);
    new ResizeObserver(setSticky).observe(side);

    function reset() {
      q.value = ''; min.value = ''; max.value = '';
      Object.values(facets).forEach((f) => { f.checked.clear(); f.fs.querySelectorAll('input').forEach((b) => { b.checked = false; }); });
      render(true);
    }

    q.addEventListener('input', debounce(() => render(true), 120));
    clearQ.addEventListener('click', () => { q.value = ''; q.focus(); render(true); });
    sort.addEventListener('change', () => render(false));
    [min, max].forEach((el) => el.addEventListener('input', debounce(() => render(true), 250)));
    root.querySelectorAll('.pfg__group[data-facet]').forEach((fs) => fs.addEventListener('change', (e) => {
      const f = facets[fs.dataset.facet]; const box = e.target;
      box.checked ? f.checked.add(box.value) : f.checked.delete(box.value); render(true);
    }));
    root.querySelectorAll('[data-pfg-reset]').forEach((b) => b.addEventListener('click', reset));
    root.querySelector('[data-pfg-open]').addEventListener('click', () => { side.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; });
    root.querySelectorAll('[data-pfg-close]').forEach((b) => b.addEventListener('click', () => { side.classList.remove('is-open'); document.documentElement.style.overflow = ''; }));
    render(false);
  });
})();

/* Shop hero search → instant grid filter */
document.querySelectorAll('[data-pfg-proxy]').forEach((form) => {
  const target = document.querySelector(form.dataset.pfgProxy);
  const gridQ = target && target.querySelector('[data-pfg-q]');
  if (!gridQ) return;
  const src = form.querySelector('input[type="search"]');
  const push = () => { gridQ.value = src.value; gridQ.dispatchEvent(new Event('input', { bubbles: true })); };
  src.addEventListener('input', push);
  form.addEventListener('submit', (e) => { e.preventDefault(); push(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
});

/* Product gallery: arrows, swipe, keys, counter, zoom lightbox */
(() => {
  const stage = document.querySelector('[data-gallery-stage]');
  if (!stage) return;
  const main = stage.querySelector('.js-gallery-main');
  const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));
  const srcs = thumbs.length ? thumbs.map((t) => t.dataset.galleryThumb) : (main ? [main.currentSrc || main.src] : []);
  const count = stage.querySelector('[data-gallery-count]');
  const box = document.querySelector('[data-lightbox]');
  const boxImg = box && box.querySelector('[data-lightbox-img]');
  let i = 0;
  const show = (n) => {
    if (!srcs.length || !main) return;
    i = (n + srcs.length) % srcs.length;
    main.removeAttribute('srcset'); main.src = srcs[i];
    thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
    if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    if (count) count.textContent = `${i + 1} / ${srcs.length}`;
    if (boxImg && !box.hidden) boxImg.src = srcs[i];
  };
  thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
  document.querySelectorAll('[data-gallery-step]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); show(i + Number(b.dataset.galleryStep)); }));
  // swipe
  let x0 = null;
  [stage, box].forEach((el) => el && el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true }));
  [stage, box].forEach((el) => el && el.addEventListener('touchend', (e) => {
    if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40 && srcs.length > 1) show(i + (dx < 0 ? 1 : -1));
  }));
  // lightbox
  const zoom = stage.querySelector('[data-gallery-zoom]');
  const open = () => { if (!box) return; boxImg.src = srcs[i] || main.src; box.hidden = false; document.documentElement.style.overflow = 'hidden'; box.querySelector('[data-lightbox-close]').focus(); };
  const close = () => { box.hidden = true; document.documentElement.style.overflow = ''; zoom && zoom.focus(); };
  zoom && zoom.addEventListener('click', open);
  box && box.querySelector('[data-lightbox-close]').addEventListener('click', close);
  box && box.addEventListener('click', (e) => { if (e.target === box) close(); });
  document.addEventListener('keydown', (e) => {
    const inField = /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
    if (box && !box.hidden && e.key === 'Escape') close();
    if (inField || srcs.length < 2) return;
    if (e.key === 'ArrowRight') show(i + 1);
    if (e.key === 'ArrowLeft') show(i - 1);
  });
  // keep variant image switching in sync with the counter
  if (main) new MutationObserver(() => { const k = srcs.findIndex((s) => main.src.split('?')[0].endsWith(s.split('?')[0].split('/').pop())); if (k > -1 && k !== i) { i = k; if (count) count.textContent = `${i + 1} / ${srcs.length}`; thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false')); } }).observe(main, { attributes: true, attributeFilter: ['src'] });
})();

/* Arriving on Shop with a search (from the homepage hero) → jump to the results */
(() => {
  const all = document.getElementById('all-parts');
  if (all && new URLSearchParams(location.search).get('q')) {
    requestAnimationFrame(() => all.scrollIntoView({ block: 'start' }));
  }
})();

/* Mobile product page: start the long Description collapsed */
(() => {
  if (window.innerWidth >= 750) return;
  const first = document.querySelector('[data-product-section] .accordion details[open]');
  if (first) first.removeAttribute('open');
})();

/* ---------- Predictive search dropdown [data-predictive] ----------
   Uses Shopify's /search/suggest.json (products + collections). Click a result to go straight to it;
   "See all results" opens the instant-filter Shop grid (/collections?q=…). Keyboard: ↑ ↓ Enter Esc. */
(() => {
  const inputs = document.querySelectorAll('input[data-predictive]');
  if (!inputs.length) return;
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = (v) => { const n = Number(String(v).replace(/[^0-9.]/g, '')); return isFinite(n) ? new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(n) : esc(v); };
  const highlight = (text, q) => {
    let out = esc(text);
    q.split(/\s+/).filter((w) => w.length > 1).forEach((w) => { out = out.replace(new RegExp(`(${w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'ig'), '<mark>$1</mark>'); });
    return out;
  };
  const cache = new Map();

  inputs.forEach((input) => {
    const form = input.closest('form');
    const host = input.closest('[data-predictive-host]') || form || input.parentElement;
    host.classList.add('ps-host');
    const box = document.createElement('div');
    box.className = 'ps';
    box.id = `${input.id || 'q'}-suggest`;
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    host.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('aria-expanded', 'false');
    let active = -1, ctrl = null, timer = null;

    const options = () => Array.from(box.querySelectorAll('[data-ps-opt]'));
    const setActive = (i) => {
      const opts = options(); if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      opts.forEach((o, k) => o.classList.toggle('is-active', k === active));
      opts[active].scrollIntoView({ block: 'nearest' });
      input.setAttribute('aria-activedescendant', opts[active].id);
    };
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const open = () => { box.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const allUrl = (q) => `${(window.JR?.routes?.root || '/').replace(/\/$/, '')}/collections?q=${encodeURIComponent(q)}`;

    const render = (q, data) => {
      const products = (data?.resources?.results?.products || []).filter((p) => !(p.tags || []).includes('sample')).slice(0, 6);
      const collections = data?.resources?.results?.collections || [];
      let n = 0;
      const prodHtml = products.map((p) => {
        const img = p.featured_image?.url || p.image;
        const src = img ? `${img}${img.includes('?') ? '&' : '?'}width=120` : '';
        return `<a href="${esc(p.url)}" class="ps__item" role="option" id="${box.id}-${n++}" data-ps-opt>
          <span class="ps__thumb">${src ? `<img src="${esc(src)}" alt="" width="56" height="56" decoding="async">` : ''}</span>
          <span class="ps__text"><span class="ps__title">${highlight(p.title, q)}</span><span class="ps__meta">${esc(p.type || '')}</span></span>
          <span class="ps__price">${money(p.price)}</span>
        </a>`;
      }).join('');
      const colHtml = collections.slice(0, 3).map((c) => `<a href="${esc(c.url)}" class="ps__chip" role="option" id="${box.id}-${n++}" data-ps-opt>${highlight(c.title, q)}</a>`).join('');
      box.innerHTML = (products.length ? `<div class="ps__label">Parts</div><div class="ps__list">${prodHtml}</div>` : `<div class="ps__empty">No parts match “${esc(q)}”. Try just the model, e.g. “iPhone 14”.</div>`) +
        (colHtml ? `<div class="ps__label">Categories</div><div class="ps__chips">${colHtml}</div>` : '') +
        `<a href="${allUrl(q)}" class="ps__all" role="option" id="${box.id}-${n++}" data-ps-opt>See all results for “${esc(q)}” <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>`;
      active = -1; open();
    };

    const search = async (q) => {
      if (cache.has(q)) return render(q, cache.get(q));
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      box.classList.add('is-loading');
      try {
        const url = `${(window.JR?.routes?.root || '/').replace(/\/$/, '')}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag`;
        const data = await (await fetch(url, { signal: ctrl.signal })).json();
        cache.set(q, data);
        if (input.value.trim() === q) render(q, data);
      } catch (e) { if (e.name !== 'AbortError') close(); }
      finally { box.classList.remove('is-loading'); }
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => search(q), 160);
    });
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2 && box.innerHTML) open(); });
    input.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); options()[active].click(); }
    });
    document.addEventListener('click', (e) => { if (!host.contains(e.target)) close(); });
    // Submitting the form (Enter with nothing highlighted / "Find part") → all results in the Shop grid
    if (form && !form.hasAttribute('data-pfg-proxy')) form.addEventListener('submit', (e) => {
      const q = input.value.trim(); if (!q) return;
      e.preventDefault(); location.href = allUrl(q);
    });
  });
})();
